import alpine from 'alpinejs';
import Lenis from 'lenis';

import { contactForm } from './blocks/contact-form';
import { expandingImage } from './blocks/expanding-image';
import { homeCarousel } from './blocks/home-carousel';
import { orderForm } from './blocks/order-form';
import { productOverview } from './blocks/product-overview';
import { reviews } from './blocks/reviews';
import { sampleServiceForm } from './blocks/sample-service-form';
import { showroomVisitForm } from './blocks/showroom-visit-form';
import { contentSingleProduct } from './partials/content-single-product';
import { autoplayVideos } from './utils/autoplay-videos';

import focus from '@alpinejs/focus';

alpine.plugin(focus);

// Alpine components must be registered before `start()` — anything registered
// afterwards is ignored. The remaining blocks still bootstrap by selector.
alpine.data('orderForm', orderForm);
alpine.data('sampleServiceForm', sampleServiceForm);
alpine.data('showroomVisitForm', showroomVisitForm);

Object.assign(window, { Alpine: alpine }).Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
  // Smooth scrolling
  new Lenis({
    autoRaf: true,
  });

  // Selectors and their corresponding init functions
  const selectors = {
    '.wp-block-home-carousel': homeCarousel,
    '.wp-block-expanding-image': expandingImage,
    '.wp-block-product-overview': productOverview,
    '.wp-block-reviews': reviews,
    'body.single-product': contentSingleProduct,
    '#contact-form': contactForm,
    'video[data-autoplay]': autoplayVideos,
  };

  // Loop through selectors and initialize those that exist in the DOM
  Object.entries(selectors).forEach(([selector, initFunction]) => {
    if (document.querySelector(selector)) {
      initFunction();
    }
  });
});
